<template>
  <section class="plan-quote-info">
    <div class="table">
      <div
        v-for="(item, index) in sidebarPremium"
        :key="index"
        class="tr">
        <span>{{ item.item }}</span>
        <span>{{ item.premium_str }}</span>
        <!--        <span>{{ item.premium | formatMoney(2, true) }}</span>-->
      </div>
    </div>
    <!-- <div
      v-if="productId == 11"
      class="table">
      <div class="tr">
        <span>Basic Premium</span>
        <span>{{ formData.pre_basic_prm }}</span>
      </div>
      <div class="tr">
        <span>NCD</span>
        <span>{{ formData.ncd_vl }}</span>
      </div>
      <div class="tr">
        <span>MGM Discount {{ formData.code_disc_pct }}%</span>
        <span>{{ formData.code_disc_prm }}</span>
      </div>
      <div class="tr">
        <span>MIB {{ formData.mib_pct }}%</span>
        <span>{{ formData.mib_vl }}</span>
      </div>
      <div
        v-if="formData.class_id == 14"
        class="tr">
        <span>Manual Discount</span>
        <span>{{ formData.spec_disc_prm }}</span>
      </div>
      <div
        v-else
        class="tr">
        <span>IA Levy</span>
        <span>{{ formData.ia_levy_vl }}</span>
      </div>
    </div>
    <div
      v-else
      class="table">
      <div class="tr">
        <span>Basic Premium</span>
        <span>{{ formData.pre_basic_prm }}</span>
      </div>
      <div
        class="tr">
        <span>IA Levy</span>
        <span>{{ formData.ia_levy_vl }}</span>
      </div>
      <div class="tr">
        <span>MGM Discount {{ formData.code_disc_pct }}%</span>
        <span>{{ formData.code_disc_prm }}</span>
      </div>
    </div> -->
  </section>
</template>
<script>
import {mapState} from 'vuex'
import MixinFormat from '@/mixins/format'

export default {
  name: 'PlanQuoteInfo',
  mixins: [MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: this.formData
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    sidebarPremium() {
      if(!this.formData) {
        return []
      }
      let { sidebar_premium=[]} =this.formData
      if(sidebar_premium.length<=0)return  []
      return sidebar_premium.filter(item => item.name != 'paid')
    },
  },
  watch: {
    formData: {
      immediate: true,
      handler(val) {
        this.form = val
      }
    }
  }
}
</script>